import { defineComponent as _defineComponent } from 'vue'
import { mdiEmailOutline, mdiFacebook, mdiInstagram, mdiLinkVariant, mdiTwitter, mdiYoutube } from '@mdi/js'
import { UserDBSocials } from '@/enitites/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSocials',
  props: {
    socials: null
  },
  setup(__props: any) {



return { __sfc: true,mdiEmailOutline, mdiFacebook, mdiInstagram, mdiLinkVariant, mdiTwitter, mdiYoutube }
}

})